export default "__VITE_ASSET__9lyXU4gi__"